export function customCheckbox(formId) {
    let _form = jQuery('#mktoForm_' + formId);
    let _checkbox = _form.find('input').is('[type="checkbox"]');

    _form.find('.mktoForms-checkbox').find('.mktoPlaceholder').parent().addClass('hidden');
    _form.find('.mktoForms-checkbox').find('.mktoFieldDescriptor').parent().removeClass('hidden');

    if (_checkbox ) {
        _form.find('input[type="checkbox"]').parent().parent().parent().parent().addClass('mktoForms-checkbox');
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/custom-checkbox.js